import React from 'react';
import Card from './Card';

const QuestionMaterialCard = ({base_url}) => {
  const fields = ['type', 'url'];
  const endpoint = `${base_url}/question-materials`;
  return <Card endpoint={endpoint} fields={fields} />;
};

export default QuestionMaterialCard;